<!------------------------------------------- template ------------------------------------------->
<template>
  <div class="smart container">
    <div class="banner container">
      <div class="banner1">
        <div class="banner-imgList">
          <div class="banner-imgList-item">
            <div @click="setFloorNavMountClick(0)">
              <img src="../assets/img/platform1.png" />
              <span>市场运营管理平台</span>
            </div>
            <div @click="setFloorNavMountClick(1)">
              <img src="../assets/img/platform2.png" />
              <span>AI智能检测系统</span>
            </div>
          </div>
          <div class="banner-imgList-item">
            <div @click="setFloorNavMountClick(7)">
              <img src="../assets/img/platform3.png" />
              <span>物联网平台</span>
            </div>
            <div @click="setFloorNavMountClick(6)">
              <img src="../assets/img/platform4.png" />
              <span>电子会员系统</span>
            </div>
          </div>
          <div class="banner-imgList-item">
            <img src="../assets/img/platform9.png" />
          </div>
          <div class="banner-imgList-item">
            <div @click="setFloorNavMountClick(2)">
              <img src="../assets/img/platform5.png" />
              <span>商户进销存平台</span>
            </div>
            <div @click="setFloorNavMountClick(3)">
              <img src="../assets/img/platform6.png" />
              <span>无人值守地磅</span>
            </div>
          </div>
          <div class="banner-imgList-item">
            <div @click="setFloorNavMountClick(5)">
              <img src="../assets/img/platform7.png" />
              <span>电子商城管理平台</span>
            </div>
            <div @click="setFloorNavMountClick(4)">
              <img src="../assets/img/platform8.png" />
              <span>支付结算系统</span>
            </div>
          </div>
        </div>
        <img src="../assets/img/systemPlatform.png" alt="" class="banner-img" />
        <img
          class="btnImg"
          src="../assets/img/btn_systemPlatform.png"
          @click="$store.commit('PageIds', true)"
        />
      </div>
    </div>
    <!--  产品构架导览  -->
    <!-- <div class="app-main">
      <div class="wholesale_programme_title1">
        <div class="wholesale_programme_title_text1 wholesale_programme_title_text2">
          产品构架导览
          <img src="../assets/img/title3@2x.png" alt=""/>
        </div>
        <div class="zhexian"></div>
      </div>
      <div class="guide_container">
        <div class="guide_top">
          <div class="guide_top_left guide_img" @click="setFloorNavMountClick(0)">
            <div class="guide_title">
              市场运营管理平台
            </div>
            <p>解决管理难题 提高效率</p>
            <p>提示用户体验</p>
          </div>
          <div class="guide_top_center guide_img" @click="setFloorNavMountClick(1)">
            <div class="guide_title">
              商户进销存平台
            </div>
            <p>适用于各种业务模式</p>
            <p>一站式管理 降本增效</p>
          </div>
          <div class="guide_top_right guide_img" @click="setFloorNavMountClick(2)">
            <div class="guide_title">
              无人值守地磅
            </div>
            <p>各应用场景自动称重 提升效率</p>
            <p>异常行为实施监测 减省损失</p>
          </div>
        </div>
        <div class="guide_center">
          <div class="guide_center_left" @click="setFloorNavMountClick(3)">
            <div class="guide_title">
              支付结算系统
            </div>
            <p>支付方式多样化 一键扫码支付</p>
            <p>自定义结算方式 灵活结算管控 全自动对账单记账</p>
          </div>
          <div class="guide_center_right guide_img" @click="setFloorNavMountClick(6)">
            <div class="guide_title">
              物联网平台
            </div>
            <p>统一控制中心 实现产品智能化</p>
            <p>多类型物联网设备统一接入</p>
          </div>
        </div>
        <div class="guide_bottom guide_top">
          <div class="guide_bottom_left guide_img" @click="setFloorNavMountClick(5)">
            <div class="guide_title">
              电子会员系统
            </div>
            <p>统一各渠道会员权益</p>
            <p>搭建成长体系 实现精细销售</p>
          </div>
          <div class="guide_center_left guide_bottom_right" @click="setFloorNavMountClick(4)">
            <div class="guide_title">
              电子商城管理平台
            </div>
            <p>一体化智能销售 线上线下业务全覆盖</p>
            <p>一站式移动商城 适应多种业务模式</p>
          </div>
        </div>
      </div>
    </div> -->
    <!--  市场运营管理平台  -->
    <div class="floor-item">
      <div class="market_box btwn">
        <img src="../assets/img/floor-market.png" alt="" />
        <div style="flex-grow: 1; margin: 120px 50px 0; font-weight: normal">
          <div class="title" style="margin-bottom: 50px">市场运营管理平台</div>
          <p>操作简单&nbsp;功能齐全</p>
          <br />
          <p>以管理者为中心以经营</p>
          <br />
          <p>一站式查看核心数据一手信息实时掌握</p>
        </div>
      </div>
    </div>
    <!-- AI智能检测系统 -->
    <div class="floor-item bg_blue">
      <div class="market_box btwn">
        <div style="flex-grow: 1; margin: 90px 50px 0">
          <div class="title" style="margin-bottom: 10px">AI智能检测系统</div>
          <p style="margin: 0; margin-bottom: 35px">
            辅助管理，实时抓拍违规行为，智能预警，节约人工成本，提高管理效率
          </p>
          <div class="wulian_box ai_box">
            <div class="wulian_img_box">
              <img src="../assets/img/floor-dui.png" alt="" />
              <span>提高市场运营效率</span>
            </div>
            <div class="wulian_img_box">
              <img src="../assets/img/floor-dui.png" alt="" />
              <span>提高市场管理效率</span>
            </div>
            <div class="wulian_img_box">
              <img src="../assets/img/floor-dui.png" alt="" />
              <span>优化市场环境</span>
            </div>
            <div class="wulian_img_box">
              <img src="../assets/img/floor-dui.png" alt="" />
              <span>降低运营成本</span>
            </div>
            <div class="wulian_img_box">
              <img src="../assets/img/floor-dui.png" alt="" />
              <span>优化市场布局和规划</span>
            </div>
          </div>
        </div>
        <img src="../assets/img/floor-AI.png" alt="" />
      </div>
    </div>
    <!--  商户进销存平台  -->
    <div class="floor-item market_box btwn">
      <img src="../assets/img/floor-merchant1.png" alt="" />
      <div class="market_con">
        <div class="title merchant_title_">商户进销存平台</div>
        <p class="left_title">多仓库库存统一管理、采购价格变化掌控、销售订单跟踪</p>
        <br />
        <div v-for="(item, i) in merchantList" :key="i">
          <div class="merchant_title">{{ item.title }}</div>
          <div class="type_box">
            <div class="merchant_type" v-for="(innerItem, index) in item.type" :key="index">
              {{ innerItem.label }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  基于物联网技术的无人值守系统  -->
    <div class="floor-item bg_blue">
      <div class="market_box btwn">
        <div class="wulian_box">
          <div class="title wulian_title" style="margin-top: 100px">基于物联网技术的无人值守系统</div>
          <p class="left_title" style="margin-bottom: 45px">无人值守、无感支付、智能车牌识别、灵活缴费配置</p>
          <div class="wulian_img_box">
            <img src="../assets/img/floor-dui.png" alt="" />
            <span>提升智能化管理 增加企业效益</span>
          </div>
          <!-- <p>
            采用禾平数据全套停车场解决方案，为您带来更高效益，全面提升车场智能化管理的同时，还能够带来可量化的经济效益
          </p> -->
          <div class="wulian_img_box">
            <img src="../assets/img/floor-dui.png" alt="" />
            <span>提升办事效率 享受便捷车主服务</span>
          </div>
          <!-- <p>为您的车主提供更多便捷的自助服务平台，提升办事效率，享受更高效且更经济实惠的停车体验</p> -->
          <div class="wulian_img_box">
            <img src="../assets/img/floor-dui.png" alt="" />
            <span>提供各类平台服务 享受更多收益</span>
          </div>
          <!-- <p>
            禾平数据无人值守停车方案还可以为您提供全套方案落地实施服务、软件平台定期维护升级、贴心产品售后支持等
          </p> -->
        </div>
        <img src="../assets/img/floor-wulian.png" alt="" />
      </div>
    </div>

    <!--  支付结算系统  -->
    <div class="floor-item market_box btwn">
      <img src="../assets/img/floor_pay.png" alt="" />
      <div class="market_con">
        <div class="title merchant_title_ merchant_title1">支付结算系统</div>
        <p class="left_title">基于数据化风控给予买家信用额度用于采购</p>
        <br />
        <div v-for="(item, i) in payList" :key="i">
          <div class="merchant_title">{{ item.title }}</div>
          <div class="type_box">
            <div class="merchant_type" v-for="(innerItem, index) in item.type" :key="index">
              {{ innerItem.label }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  商城订单 高效管理  -->
    <div class="floor-item bg_blue">
      <div class="market_box btwn">
        <div class="shop_box">
          <div class="title market_title market_title2" style="margin-bottom: 40px">商城订单 高效管理</div>
          <p class="shop_content">
            用户下单后，系统会根据不同商家拆单，将对应订单分配给相应商家，商家对商品进行发货
          </p>
          <!-- <p>后台根据订单状态将订单分为待付款、待发货、待收货等，帮助商家提高订单管理效率</p> -->
          <p class="shop_content">配送订单可在后台进行物流发货操作，自提订单可在后台进行核销</p>
          <!-- <p>订单退货退款审核处理</p> -->
        </div>
        <img src="../assets/img/floor-shangcheng.png" alt="" />
      </div>
    </div>

    <!--  电子会员系统  -->
    <div class="floor-item market_box btwn">
      <img src="../assets/img/floor-dianzi.png" alt="" />
      <div class="market_con">
        <div class="title merchant_title_ merchant_title3" style="margin-bottom: 25px">电子会员系统</div>
        <div v-for="(item, i) in eList" :key="i">
          <div class="merchant_title">{{ item.title }}</div>
          <p class="e_p">{{ item.p }}</p>
        </div>
      </div>
    </div>

    <!--  物联网平台  -->
    <div class="floor-item bg_blue">
      <div class="market_box btwn">
        <div class="market_con">
          <div class="title merchant_title_ merchant_title3" style="margin-bottom: 5px">物联网平台</div>
          <br />
          <div v-for="(item, i) in wuList" :key="i">
            <div class="merchant_title" style="margin-top: 18px">{{ item.title }}</div>
            <p class="e_p" style="margin-left: 0; line-height: 50px">{{ item.p }}</p>
          </div>
        </div>
        <img src="../assets/img/floor-wulianwang.png" alt="" />
      </div>
    </div>

    <!--  楼层区域   -->
    <!-- <div class="floor_nav_box" v-show="showFlor">
      <section class="floor-nav" id="floorNavList">
        <ul class="nav-list">
          <li
            class="nav-list-item"
            v-for="(item, index) in floorList"
            :key="item.id"
            @click="setFloorNavMountClick(index)"
          >
            <div class="floor_con">
              <div class="cercle_active">
                <div class="cercle_big"></div>
                <div class="cercle_small"></div>
              </div>
              <div>{{ item.name }}</div>
            </div>
            <div class="floor_line" v-if="index != floorList.length - 1"></div>
          </li>
        </ul>
      </section>
    </div> -->
  </div>
</template>

<!-------------------------------------------- script -------------------------------------------->
<script>
import SuccessCase from '@/components/solution/successCase'

export default {
  name: '',
  components: {
    SuccessCase
  },

  data() {
    return {
      nowList: [
        {
          image: require('../assets/img/cufang.png'),
          title: '传统管理粗放',
          p1: '传统的园区运营管理缺少对人',
          p2: '车货的有效管理, 对商户服',
          p3: '务较为简单和初级'
        },
        {
          image: require('../assets/img/geli.png'),
          title: '园区系统隔离',
          p1: '园区设备系统种类繁多, 各厂',
          p2: '家互不连通、互相隔离, 系统',
          p3: '间无法有效联动'
        },
        {
          image: require('../assets/img/danyi.png'),
          title: '园区服务单一',
          p1: '园区业务核心为物业出租的',
          p2: '房地产模式,缺乏配套支撑和',
          p3: '针对性的个性化服务'
        },
        {
          image: require('../assets/img/fensan.png'),
          title: '运营数据分散',
          p1: '园区运营过程中产生大量数',
          p2: '据, 各系统数据分散不能整',
          p3: '合, 数据价值大打折扣'
        }
      ],
      // 产品体系
      systemList: [
        {
          url: require('../assets/img/zulin.png'),
          p1: '租赁管理',
          p2: '市场资源全方位管理',
          p3: '轻松打造智慧市场'
        },
        {
          url: require('../assets/img/shoufei.png'),
          p1: '收费管理',
          p2: '费用项目灵活定义',
          p3: '便捷快速的支付通道'
        },
        {
          url: require('../assets/img/wuye.png'),
          p1: '物业服务',
          p2: '物业全面数字化智能管理',
          p3: '帮助市场最大程度降本增效'
        },
        {
          url: require('../assets/img/shuju.png'),
          p1: '数据分析',
          p2: '自定义各类报表',
          p3: '通过不同维度联动分析'
        },
        {
          url: require('../assets/img/yuanquhexin.png'),
          p1: '园区巡查',
          p2: '灵活配置点检巡查',
          p3: '数据实时上传清晰易查'
        },
        {
          url: require('../assets/img/caiwu.png'),
          p1: '财务管理',
          p2: '实时监控财务情况',
          p3: '管理资金流动情况 便捷对账'
        },
        {
          url: require('../assets/img/jinchu.png'),
          p1: '进出场管理',
          p2: '停车管理系统+智能硬件对接',
          p3: '为智慧停车提供一体化解决方案'
        },
        {
          url: require('../assets/img/hulianwang.png'),
          p1: '互联网开放平台',
          p2: '配备多种智能公示大屏',
          p3: '全方位掌握市场内部资讯'
        }
      ],
      // 商户进销存平台
      merchantList: [
        {
          title: '店铺经营',
          type: [
            {
              label: '商品管理'
            },
            {
              label: '进货管理'
            },
            {
              label: '开单销售'
            },
            {
              label: '库存管理'
            },
            {
              label: '客户管理'
            },
            {
              label: '资金管理'
            },
            {
              label: '经营分析'
            },
            {
              label: '店铺管理'
            }
          ]
        },
        {
          title: '市场业务办理',
          type: [
            {
              label: '进场登记'
            },
            {
              label: '仓储出入库'
            },
            {
              label: '在线缴费'
            },
            {
              label: '市场服务申请'
            },
            {
              label: '资金管理'
            },
            {
              label: '经营分析'
            },
            {
              label: '店铺管理'
            }
          ]
        }
      ],
      // 支付结算系统
      payList: [
        {
          title: '系统机制',
          type: [
            {
              label: '聚合支付'
            },
            {
              label: '一键扫码'
            },
            {
              label: '支持多种支付方式'
            },
            {
              label: '统一结算分账'
            }
          ]
        },
        {
          title: '市场业务办理',
          type: [
            {
              label: '支付无阻'
            },
            {
              label: '避免二清'
            },
            {
              label: '节省人力'
            },
            {
              label: '提供增值服务'
            }
          ]
        }
      ],

      // 电子会员系统
      eList: [
        {
          title: '会员码付款',
          p: '省去繁琐切换扫码步骤，实现一次扫码'
        },
        {
          title: '在线充值',
          p: '提供方便快捷的充值方式，省去排队等待的麻'
        },
        {
          title: '消费券核销',
          p: '有效推动消费券的使用和普及，刺激消费、促进经济发展'
        },
        {
          title: '订单记录',
          p: '帮助市场实现精细化管理，提高客户服务水平，优化销售策略，加强库存管理，以及控制风险等'
        }
      ],
      // 物联网平台
      wuList: [
        {
          title: '智能电表',
          p: '欠费预警，自动断电，避免人为尴尬'
        },
        {
          title: '信息统计',
          p: '告别纸质台账，节约人工成本，提高效率，信息一览无余'
        },
        {
          title: '智能地磅',
          p: '欠费预警，自动断电，避免人为尴尬'
        }
      ],
      // 楼层导航
      element: {
        nav_item: null,
        floor_item: null,
        cercle_big: null,
        cercle_small: null
      },
      timer: null,
      floorList: [
        { id: 1, name: '市场运营管理平台' },
        { id: 2, name: 'AI智能检测系统' },
        { id: 3, name: '商户进销存平台' },
        { id: 4, name: '无人值守地磅' },
        { id: 5, name: '支付结算系统' },
        { id: 6, name: '电子商城管理平台' },
        { id: 7, name: '电子会员系统' },
        { id: 8, name: '物联网平台' }
      ],
      showFlor: false,
      height: 0,
      percent: 1,
      floor_index: 0,
      imgList: [
        require('../assets/img/platform1.png'),
        require('../assets/img/platform2.png'),
        require('../assets/img/platform3.png'),
        require('../assets/img/platform4.png'),
        require('../assets/img/platform5.png'),
        require('../assets/img/platform6.png'),
        require('../assets/img/platform7.png'),
        require('../assets/img/platform8.png'),
        require('../assets/img/platform9.png')
      ]
    }
  },

  /* 一.生命周期函数 */
  created() {},

  mounted() {
    this.element = {
      //   nav_item: document.getElementsByClassName('nav-list-item'),
      floor_item: document.getElementsByClassName('floor-item')
      //   cercle_big: document.getElementsByClassName('cercle_big'),
      //   cercle_small: document.getElementsByClassName('cercle_small')
    }
    // this.element.nav_item[0].classList.add('active')
    // this.element.cercle_big[0].classList.add('cercle_big_active')
    // this.element.cercle_small[0].classList.add('cercle_small_active')
    // window.addEventListener('scroll', this.floorSrcollEventListener)
    // window.addEventListener('resize', this.changePercent)
    this.percent = document.getElementsByTagName('body')[0].style.zoom
    const pageHeight = document.documentElement.clientHeight
    console.log(pageHeight, 'pageHeight')
    // if (pageHeight > 650) {
    // this.height = 400
    // }else if(pageHeight >1200 && pageHeight <= 1400){
    // this.height = 950
    // } else {
    this.height = 350 * this.percent
    // }
    // this.floorSrcollEventListener()
    console.log('页面高度：' + pageHeight)
  },

  beforeDestroy() {
    // window.removeEventListener('scroll', this.floorSrcollEventListener)
    // window.removeEventListener('resize', this.changePercent)
  },

  /* 二.监控函数 */
  watch: {},

  computed: {},

  /* 三.内部功能函数 */
  methods: {
    changePercent() {
      this.percent = document.getElementsByTagName('body')[0].style.zoom
      document.documentElement.scrollTop = 0
    },
    getScrollbarHeight() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      var clientHeight = document.documentElement.clientHeight || document.body.clientHeight

      // 滚动条的高度 = 总高度 - 可见区域的高度
      var scrollbarHeight = scrollHeight - clientHeight

      return scrollbarHeight
    },
    /**
     * 设置楼层导航事件驱动方法
     * @param {Number} index  楼层下标
     */
    setFloorNavMountClick(index) {
      if (this.floor_index == index) return
      this.floor_index = index
      const { floor_item } = this.element
      console.log(floor_item, index, floor_item[index].offsetTop, floor_item[0].offsetTop)
      const floor_offsetTop =
          floor_item[index].offsetTop * this.percent - floor_item[0].offsetTop * this.percent,
        window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop,
        timer = {
          step: 460 * this.percent,
          times: 50,
          FLOOR_OFFSETTOP: floor_offsetTop + this.height
        }
      this.floor_index = index
      // console.log(window_scrollTop, floor_offsetTop, 999)
      if (window_scrollTop > floor_offsetTop) {
        this.setFloorScrollArrowUp(timer)
      } else {
        this.setFloorScrollArrowDown(timer)
      }
    },
    /**
     * 设置楼层向上滚动
     * @param {Object} timer 定时器配置
     */
    setFloorScrollArrowUp(timer) {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        let window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        console.log(timer.FLOOR_OFFSETTOP, 'timer.FLOOR_OFFSETTOP up')
        if (window_scrollTop <= timer.FLOOR_OFFSETTOP) {
          document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP + 1
          document.body.scrollTop = timer.FLOOR_OFFSETTOP + 1
          clearInterval(this.timer)
        } else {
          document.documentElement.scrollTop = window_scrollTop - timer.step
          document.body.scrollTop = window_scrollTop - timer.step
        }
      }, timer.times)
    },
    /**
     * 设置楼层向下滚动
     * @param {Object} timer 定时器配置
     */
    setFloorScrollArrowDown(timer) {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        let window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        console.log(window_scrollTop, timer.FLOOR_OFFSETTOP, 'timer.FLOOR_OFFSETTOP down')
        if (window_scrollTop + 500 >= timer.FLOOR_OFFSETTOP) {
          document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP + 1
          document.body.scrollTop = timer.FLOOR_OFFSETTOP + 1
          clearInterval(this.timer)
        } else {
          document.documentElement.scrollTop = window_scrollTop + timer.step
          document.body.scrollTop = window_scrollTop - timer.step
        }
      }, timer.times)
    },
    /**
     * 监听窗口滚动楼层导航动态定位
     */
    floorSrcollEventListener() {
      const { nav_item, floor_item, cercle_big, cercle_small } = this.element
      const window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (window_scrollTop >= this.height - 35) {
        this.showFlor = true
      } else {
        this.showFlor = false
      }
      // console.log(window_scrollTop, 'window_scrollTop')
      for (let i = 0, len = floor_item.length; i < len; i++) {
        let floor_offsetTop =
          floor_item[i].offsetTop * this.percent - floor_item[0].offsetTop * this.percent + this.height
        let floor_offsetBottom = false
        if (i < floor_item.length - 1) {
          floor_offsetBottom =
            floor_item[i + 1].offsetTop * this.percent - floor_item[0].offsetTop * this.percent
        } else {
          floor_offsetTop -= 400 * this.percent
        }
        // console.log(floor_item[i].offsetTop, floor_item[0].offsetTop, '======')
        // let floor_offsetTop = floor_item[i].offsetTop
        // console.log(
        //   'window_scrollTop,floor_offsetTop,floor_offsetBottom',
        //   window_scrollTop,
        //   floor_offsetTop,
        //   floor_offsetBottom
        // )
        // 3260 3570 false
        if (
          window_scrollTop >= floor_offsetTop &&
          (!floor_offsetBottom || window_scrollTop <= floor_offsetBottom)
        ) {
          for (let n = 0, len = nav_item.length; n < len; n++) {
            const current_classList = nav_item[n].classList
            const big_classList = cercle_big[n].classList
            const small_classList = cercle_small[n].classList
            // console.log('i,n', i, n)
            if (i === n) {
              // console.log(current_classList, '-------------------------------------')
              current_classList.add('active')
              big_classList.add('cercle_big_active')
              small_classList.add('cercle_small_active')
            } else {
              current_classList.remove('active')
              big_classList.remove('cercle_big_active')
              small_classList.remove('cercle_small_active')
            }
            // i === n
            //     ? current_classList.add('active')
            //     : current_classList.remove('active')
          }
        }
      }
    }
  }
}
</script>

<!--------------------------------------------- style -------------------------------------------->
<style scoped>
.banner {
  width: 100%;
  min-width: 1680px;
}

.banner1 {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  position: relative;
}

.banner1 .banner-img {
  width: 100%;
  height: auto;
}

.banner1 .btnImg {
  cursor: pointer;
  width: 174px;
  height: auto;
  position: absolute;
  left: 18.75%;
  top: 71.66%;
}

.banner-imgList {
  position: absolute;
  left: 50%;
  display: flex;
  flex-wrap: wrap;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  text-align: center;
  width: 650px;
  padding-top: 47px;
}
.banner-imgList-item div {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.banner-imgList-item:nth-child(1),
.banner-imgList-item:nth-child(5) {
  width: 100%;
  display: flex;
  justify-content: center;
}
.banner-imgList-item:nth-child(1) div:first-child,
.banner-imgList-item:nth-child(5) div:first-child {
  margin-right: 18px;
}
.banner-imgList-item:nth-child(2) div:first-child,
.banner-imgList-item:nth-child(4) div:first-child {
  margin-bottom: 25px;
}
.banner-imgList-item:nth-child(2n) {
  display: flex;
  flex-direction: column;
}
.banner-imgList-item:nth-child(1) {
  transform: translateY(25px);
}
.banner-imgList-item:nth-child(5) {
  transform: translateY(-25px);
}
.banner-imgList-item:nth-child(2) {
  transform: translateX(30px);
}
.banner-imgList-item:nth-child(4) {
  transform: translateX(-30px);
}
.banner-imgList-item:nth-child(3) {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}
.banner-imgList-item:nth-child(3) img {
  width: 147px;
  height: 151px;
}

.banner-imgList-item img {
  width: 158px;
  height: 86px;
}

.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -15px;
  z-index: -1;
}

.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 16px auto 0;
}

.wholesale_programme_title1 {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text1 {
  width: 240px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  z-index: 99;
}

.wholesale_programme_title_text1 img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -5px;
  z-index: -1;
}

.wholesale_programme_title_text2 {
  width: 205px;
}

.app-main {
  margin: 73px auto 48px;
}

.app-right img {
  width: 100%;
  height: 100%;
}

.left-item-img img {
  width: 50px;
  height: 50px;
}

.think_container img {
  width: 30px;
  height: 28px;
  margin-right: 10px;
}

.guide_container {
  width: 1200px;
  margin: 50px auto 0;
  text-align: left;
}

.now_container p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.system img {
  width: 160px;
  height: 116px;
  margin: 24px;
}

.systembox_title span {
  display: inline-block;
  text-align: center;
  width: 40px;
  height: 20px;
  background: #ffb300;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  vertical-align: middle;
  margin-top: -5px;
}

.guide_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.guide_img {
  width: 388px;
  height: 210px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 36px 24px;
  box-sizing: border-box;
}

.guide_top_left {
  background-image: url('../assets/img/guide_shichang.png');
}

.guide_top_center {
  background-image: url('../assets/img/guide_shanghu.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.guide_top_right {
  background-image: url('../assets/img/guide_wuren.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.guide_title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
}

.guide_container p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1958c4;
  margin-top: 10px;
}

.guide_center {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 18px auto;
}

.guide_center_left {
  width: 794px;
  height: 210px;
  background-image: url('../assets/img/guide_zhifu.png');
  padding: 36px 24px;
  box-sizing: border-box;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.guide_center_right {
  background-image: url('../assets/img/guide_wulianwang.png');
}

.guide_bottom_left {
  background-image: url('../assets/img/guide_dianzi.png');
}

.guide_bottom_right {
  background-image: url('../assets/img/guide_shangcheng.png');
}

.market_box img {
  width: 600px;
  height: 460px;
}

.btwn {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}

.bg_blue {
  width: 100%;
  background: #f7fbff;
}

.title {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
}

.market_title {
  margin: 100px 49px 50px;
}

.bg_blue p {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-left: 50px;
  line-height: 28px;
  width: 500px;
  margin-right: 53px;
}

.merchant_title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin-top: 14px;
}

.merchant_type {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  padding: 4px 16px;
  background: #e9f4ff;
  margin-right: 8px;
  margin-top: 10px;
}

.type_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.market_con {
  padding-left: 68px;
}

.merchant_title_ {
  margin-top: 51px;
}

.ai_box {
  display: flex;
  flex-wrap: wrap;
}

.ai_box .wulian_img_box {
  margin: 0;
  width: 50%;
  margin-bottom: 25px;
}

.wulian_box img {
  width: 22px;
  height: 22px;
  margin-right: 3px;
}

.wulian_box p {
  margin-top: 4px;
}

.wulian_title {
  margin: 36px 49px 6px;
}

.wulian_img_box {
  margin: 0 49px 20px;
  display: flex;
  align-items: center;
}

.wulian_img_box span {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ff7308;
}

.left_title {
  font-size: 19px !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 5px;
  line-height: 28px;
}

.merchant_title1 {
  margin-top: 86px;
}

.market_title2 {
  margin-top: 63px;
  margin-bottom: 40px;
}

.shop_box p {
  margin-bottom: 20px;
}

.shop_content {
  line-height: 40px !important;
}

.shop_content::before {
  content: '·';
  width: 8px;
  height: 8px;
  background: #1958c4;
  display: inline-block;
  border-radius: 50%;
  line-height: 6px;
  margin-right: 5px;
}

.e_p {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  margin-top: 4px;
}

.merchant_title3 {
  margin-top: 37px;
}

.floor-nav {
  position: fixed;
  top: 200px;
  left: 50px;
}

.nav-list {
  width: 172px;
  padding: 0;
  display: inline-block;
  text-align: center;
  color: #676767;
}

.nav-list-item {
  display: inline-block;
  width: 100%;
  line-height: 48px;
  cursor: pointer;
}

.floor_con {
  display: flex;
  align-items: center;
}

.nav-list-item.active,
.nav-list-item:hover {
  color: #1958c4;
  border-bottom: none !important;
}

.cercle_big.cercle_big_active {
  background: #1958c4;
  opacity: 0.39;
}

.floor_con:hover .cercle_small {
  background: #1958c4;
  opacity: 1;
}

.floor_con:hover .cercle_big {
  background: #1958c4;
  opacity: 0.39;
}

.cercle_small.cercle_small_active {
  background: #1958c4;
  opacity: 1;
}

.floor-item {
  height: 460px;
}
.floor-item p {
  font-size: 20px;
}
.cercle_big {
  width: 28px;
  height: 28px;
  background: #000000;
  opacity: 0.19;
  position: absolute;
  border-radius: 50%;
}

.cercle_small {
  width: 16px;
  height: 16px;
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 6px;
  left: 6px;
  border-radius: 50%;
}

.cercle_active {
  position: relative;
  width: 28px;
  height: 28px;
  margin-right: 16px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
}

.floor_line {
  width: 2px;
  height: 28px;
  background: #979797;
  margin-left: 14px;
}

.guide_img:hover,
.guide_center_left:hover {
  cursor: pointer;
}
@media screen and (max-width: 1440px) {
  .banner-imgList {
    width: 520px;
    padding-top: 38px;
    font-size: 16px;
  }
  .banner-imgList-item:nth-child(1) div:first-child,
  .banner-imgList-item:nth-child(5) div:first-child {
    margin-right: 14.5px;
  }
  .banner-imgList-item:nth-child(2) div:first-child,
  .banner-imgList-item:nth-child(4) div:first-child {
    margin-bottom: 20px;
  }
  .banner-imgList-item:nth-child(1) {
    transform: translateY(20px);
  }
  .banner-imgList-item:nth-child(5) {
    transform: translateY(-20px);
  }
  .banner-imgList-item:nth-child(2) {
    transform: translateX(24px);
  }
  .banner-imgList-item:nth-child(4) {
    transform: translateX(-24px);
  }
  .banner-imgList-item:nth-child(3) img {
    width: 117.6px;
    height: 120.8px;
  }

  .banner-imgList-item img {
    width: 126.4px;
    height: 68.8px;
  }
}
/* @media screen and (max-width: 1280px) {
  .banner-imgList {
    width: 390px;
    padding-top: 28.2px;
    font-size: 15px;
  }
  .banner-imgList-item:nth-child(1) div:first-child,
  .banner-imgList-item:nth-child(5) div:first-child {
    margin-right: 10.8px;
  }
  .banner-imgList-item:nth-child(2) div:first-child,
  .banner-imgList-item:nth-child(4) div:first-child {
    margin-bottom: 15px;
  }
  .banner-imgList-item:nth-child(1) {
    transform: translateY(15px);
  }
  .banner-imgList-item:nth-child(5) {
    transform: translateY(-15px);
  }
  .banner-imgList-item:nth-child(2) {
    transform: translateX(18px);
  }
  .banner-imgList-item:nth-child(4) {
    transform: translateX(-18px);
  }
  .banner-imgList-item:nth-child(3) img {
    width: 88.2px;
    height: 90.6px;
  }

  .banner-imgList-item img {
    width: 94.8px;
    height: 51.6px;
  }
} */
</style>
